import { CalendarToday as CalendarTodayIcon } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { DateTime } from "luxon";
import type { InactivityOverlayEvent } from "../functions/generateInactivitySchedule.function";
import useTimeFormat from "../../../../hooks/useTimeFormat/useTimeFormat";
import { ScheduleInfoPopperShell } from "./ScheduleInfoPopperShell.partial";

type P = {
  popperId: string | undefined;
  popperOpen: boolean;
  anchorEl: HTMLElement | null;
  timezone: string;
  inactivitySchedule: InactivityOverlayEvent;
  onClose: () => void;
};

export function ScheduleInactivityInfoPopper({
  popperId,
  popperOpen,
  anchorEl,
  timezone,
  inactivitySchedule,
  onClose
}: Readonly<P>) {
  const { dateFormat, timeFormat } = useTimeFormat();
  const localeFullFormat = dateFormat + " " + timeFormat;
  const inactivityScheduleStart = DateTime.fromISO(inactivitySchedule.start)
    .setZone(timezone)
    .toFormat(localeFullFormat);
  const inactivityScheduleEnd = DateTime.fromISO(inactivitySchedule.end)
    .setZone(timezone)
    .toFormat(localeFullFormat);

  return (
    <ScheduleInfoPopperShell
      anchorEl={anchorEl}
      backdropTestId="inactivity-popper-backdrop"
      onClose={onClose}
      popperId={popperId}
      popperOpen={popperOpen}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <CalendarTodayIcon
          sx={theme => ({
            color: theme.palette.primary.main,
            fontSize: "1.2rem"
          })}
        />
        <Typography
          variant="body1"
          sx={theme => ({
            color: theme.palette.text.primary,
            fontWeight: 500,
            lineHeight: 1.4
          })}
        >
          {inactivitySchedule.title}
        </Typography>
      </Box>
      <Typography
        variant="body2"
        sx={theme => ({
          mt: 1,
          color: theme.palette.text.secondary
        })}
      >
        {`${inactivityScheduleStart} - ${inactivityScheduleEnd}`}
      </Typography>
      {inactivitySchedule.message?.trim() && (
        <Typography sx={{ mt: 0.5 }} variant="body2">
          {inactivitySchedule.message}
        </Typography>
      )}
    </ScheduleInfoPopperShell>
  );
}
